export default __webpack_public_path__ + "static/media/pic9.cc3ea07d.jpg";